import { gql } from 'apollo-boost';

const manyQuery = gql`
  query {
    allUsers {
      id
      clubId
      firstName
      lastName
      middleName
      enFullName
      fullName
      gender
      status
      types
      email
      permissions
      rank
      birthday
      trainerIds
      phone
      address
      qualification
      sections
      club {
        id
        shortName
      }
      photo {
        id
        url
      }
    }
  }
`;

const oneQuery = gql`
  query user($id: Int!) {
    user(id: $id) {
      id
      clubId
      firstName
      lastName
      middleName
      enFullName
      fullName
      email
      gender
      status
      types
      permissions
      rank
      birthday
      trainerIds
      phone
      address
      qualification
      leagueId
      sections
      permissionsGymIds
      mainTrainerId
      club {
        id
        shortName
      }
      photo {
        id
        url
      }
    }
  }
`;

export const updateMutation = gql`
  mutation updatePermissions($id: Int!, $inputData: UsersInputType!) {
    updatePermissions(id: $id, inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const deleteMutation = gql`
  mutation deleteAthlete($id: Int!) {
    deleteAthlete(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

const USERS = {
  manyQuery,
  oneQuery,
  updateMutation,
  deleteMutation,
};

export default USERS;
